import type { PolicyProductConfigBase } from '~/components/types/incident-configuration-types';

export const BROKER_ROLE_KEY = 'broker';
export const BROKER_DEFAULT_LABEL = 'Broker';

export interface BrokerFieldConfig {
  active: boolean;
  desc: string;
  mandatory: boolean;
  acceptedRoles: string[];
}

export const getBrokerFieldConfig = (
  incidentConfiguration: { policy?: PolicyProductConfigBase } | undefined
): BrokerFieldConfig | undefined => {
  const raw = incidentConfiguration?.policy?.pre_defined_fields?.broker_contact_id;
  if (!raw) return undefined;
  return {
    active: raw.active === true,
    desc: raw.desc || BROKER_DEFAULT_LABEL,
    mandatory: raw.mandatory === true,
    acceptedRoles: raw.accepted_roles?.length ? raw.accepted_roles : [BROKER_ROLE_KEY],
  };
};
